import { createSelector } from 'reselect';
import { sortBy } from 'lodash';
import moment from 'moment';

const getAllNotifications = state => state.notifications.notifications;
const getNotViewedNotifications = state => state.notifications.notViewedNotifications;
const getServerDateTime = state => state.statics.serverDateTime;

// Both dates carry explicit UTC offsets; comparing them in the local system/browser
// timezone (moment's default) makes "days since" non-deterministic — the same data can
// come out a day off depending on where the code runs. Normalizing both to UTC before
// taking startOf('day') keeps the calendar-day boundary consistent everywhere.
const calculateDays = (notifications, serverDateTime) => notifications && notifications.map((notification) => {
  return {
    ...notification,
    days: moment.utc(serverDateTime).startOf('day').diff(moment.utc(notification.created).startOf('day'), 'days'),
  };
});

export const mapAllNotificationsDays = createSelector(
  [getAllNotifications, getServerDateTime],
  (notifications, serverDateTime) => calculateDays(notifications, serverDateTime)
);

export const mapFilteredNotificationsDays = createSelector(
  [getNotViewedNotifications, getServerDateTime],
  (notifications, serverDateTime) => calculateDays(notifications, serverDateTime)
);
